"use client";

import { Reveal, TextReveal, ClipReveal } from "@/components/marketing/animations";

const GALLERY_CARDS = [
  {
    slug: "dress",
    caption: "La robe qui tra\u00eenait depuis 6 mois",
  },
  {
    slug: "sneakers",
    caption: 'Les Air Max "port\u00e9es deux fois"',
  },
  {
    slug: "bag",
    caption: 'Le sac "cadeau de tata" devenu tr\u00e9sor',
  },
];

export default function GallerySection() {
  return (
    <section
      id="gallery"
      style={{ padding: "80px 0 60px", overflow: "hidden" }}
    >
      <h2
        style={{
          fontFamily: "var(--font-headline), Georgia, serif",
          fontStyle: "italic",
          fontSize: "clamp(32px, 4.5vw, 56px)",
          textAlign: "center",
          marginBottom: 60,
          padding: "0 24px",
        }}
      >
        <TextReveal text="Personne ne clique sur une photo floue." stagger={0.05} />
      </h2>

      {/* Horizontal scroll container */}
      <div
        className="gallery-scroll"
        style={{
          display: "flex",
          gap: 28,
          padding: "0 24px 20px",
          overflowX: "auto",
          scrollSnapType: "x mandatory",
          WebkitOverflowScrolling: "touch",
          scrollbarWidth: "none",
          msOverflowStyle: "none",
        }}
      >
        <style>{`
          .gallery-scroll::-webkit-scrollbar { display: none; }
          .gallery-card-wrap {
            flex: 0 0 600px;
            scroll-snap-align: start;
          }
          @media (max-width: 768px) {
            .gallery-card-wrap { flex: 0 0 340px; }
          }
        `}</style>

        {GALLERY_CARDS.map((card, idx) => (
          <Reveal key={idx} className="gallery-card-wrap">
            <div
              className="gallery-card"
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: 16,
                background: "white",
                borderRadius: 20,
                padding: 24,
                boxShadow: "0 8px 32px rgba(44,37,32,0.06)",
              }}
            >
              {/* AVANT side */}
              <div style={{ position: "relative" }}>
                <div
                  style={{
                    fontWeight: 700,
                    fontSize: 11,
                    letterSpacing: 2,
                    textTransform: "uppercase" as const,
                    marginBottom: 10,
                    color: "var(--color-mkt-terracotta, #D4613A)",
                  }}
                >
                  AVANT
                </div>
                <ClipReveal from="left" delay={0.1}>
                  <img
                    src={`/marketing/${card.slug}-bad.webp`}
                    alt={`${card.caption} - avant`}
                    style={{
                      width: "100%",
                      aspectRatio: "3/4",
                      borderRadius: 12,
                      objectFit: "cover",
                      display: "block",
                    }}
                  />
                </ClipReveal>
                <div
                  style={{
                    fontFamily: "var(--font-hand, 'Caveat', cursive)",
                    fontSize: 18,
                    position: "absolute",
                    bottom: 12,
                    right: 12,
                    transform: "rotate(-4deg)",
                    color: "var(--color-mkt-terracotta, #D4613A)",
                  }}
                >
                  {"\u00e7"}a, non
                </div>
              </div>

              {/* APRES side */}
              <div style={{ position: "relative" }}>
                <div
                  style={{
                    fontWeight: 700,
                    fontSize: 11,
                    letterSpacing: 2,
                    textTransform: "uppercase" as const,
                    marginBottom: 10,
                    color: "var(--color-mkt-forest, #3A7D5C)",
                  }}
                >
                  APR{"\u00c8"}S
                </div>
                <ClipReveal from="right" delay={0.3}>
                  <div
                    style={{
                      width: "100%",
                      aspectRatio: "3/4",
                      borderRadius: 12,
                      overflow: "hidden",
                      display: "grid",
                      gridTemplateColumns: "1fr 1fr",
                      gridTemplateRows: "1fr 1fr",
                      gap: 2,
                    }}
                  >
                    {[1, 2, 3, 4].map((n) => (
                      <img
                        key={n}
                        src={`/marketing/${card.slug}-good-${n}.webp`}
                        alt=""
                        style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: 4 }}
                      />
                    ))}
                  </div>
                </ClipReveal>
                <div
                  style={{
                    fontFamily: "var(--font-hand, 'Caveat', cursive)",
                    fontSize: 18,
                    position: "absolute",
                    bottom: 12,
                    right: 12,
                    transform: "rotate(-4deg)",
                    color: "var(--color-mkt-forest, #3A7D5C)",
                  }}
                >
                  oui !
                </div>
              </div>

              {/* Caption */}
              <div
                style={{
                  gridColumn: "1 / -1",
                  textAlign: "center",
                  fontSize: 14,
                  color: "rgba(44,37,32,0.6)",
                  fontStyle: "italic",
                  paddingTop: 4,
                }}
              >
                {card.caption}
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
